import { AppDate } from '../envTypes';

import { Profile } from './profile';
import { Order } from './order';
import { ModerationStatus } from './moderation';

export interface MessageBase {
  type: 'orderVideoMessage' | 'otherMessageType';
  userIdFrom: string;
  userProfileFrom: Profile;
  userIdTo: string;
  userProfileTo: Profile;
  createdAt: AppDate;
}

type OrderVisibilityType = 'public' | 'private';

export type VideoTranscodeStatus =
  | 'none'
  | 'processing'
  | 'transcode'
  | 'error';

export enum MessageReportResolveStatus {
  Unresolved = 'Unresolved',
  Resolved = 'Resolved',
  Dismissed = 'Dismissed',
}

export enum MessageThankYouType {
  RecipientToBuyer = 'RecipientToBuyer',
  SellerToBuyer = 'SellerToBuyer',
}

export enum MessagePurpose {
  review = 'review',
  thankYou = 'thankYou',
}

export enum MessageShowType {
  liveStream = 'liveStream',
  upcomingShow = 'upcomingShow',
}

export enum OrderVideoReviewEmoji {
  RollingEyesFace = 'rolling_eyes_face',
  Sweat = 'sweat',
  Blush = 'blush',
  Smile = 'smile',
  HeartEyes = 'heart_eyes',
}

export interface OrderVideoMessage extends MessageBase {
  orderId: string;
  buyerId: string;
  sellerId: string;
  videoURL: string;
  originalVideoURL?: string;
  transcodeStatus: VideoTranscodeStatus;
  type: 'orderVideoMessage';
  gifURL?: string;
  thumbnailURL?: string;
  emoji?: OrderVideoReviewEmoji;
  visibility: OrderVisibilityType;
  available: boolean;

  purpose?: MessagePurpose;
  order?: Order;
  show?: {
    showName: string;
    showImage?: string;
    showId: string;
    showType: MessageShowType;
  };
  // review v2 https://www.notion.so/popshoplive/Ready-Reviews-V2-dc66a60157544303a902c6aeb6d43e4f
  upvoteCount?: number;
  totalReportCount?: number;
  newReportCount?: number; //reset newReportCount to 0 when admin dismiss message reports or change message available property
  reportResolveStatus?: MessageReportResolveStatus;
  thankYouType?: MessageThankYouType;
  // if true, will show in top reviews row
  featured?: boolean;
}

export type Message = OrderVideoMessage;

export enum VideoUploadType {
  storePreview = 'storePreview',
}

// /videoUploads/{id}
export interface BaseVideoUpload {
  type: VideoUploadType;
  originalURL: string;
  encodedURL?: string;
  userId: string;
  status: VideoTranscodeStatus;
  error?: string;

  /**** moderation start ***/
  moderationStatus?: ModerationStatus;
  moderatedBy?: 'AI' | 'User';
  moderatedAt?: AppDate;
  moderatorProfile?: Pick<
    Profile,
    'firstName' | 'lastName' | 'username' | 'avatar'
  > & { fullName: string };
  moderatorUserId?: string;
  // such as "Spam", "Adult Content", etc
  moderationFlag?: string;
  // user can provide an extra msg
  moderationAdditionalMsg?: string;
  // admin can provide his own reason for approval or disapproval
  adminModerationReason?: string;
  aiStorage?: {
    json_s3_file_key?: string;
    expected_processed_time?: number;
    // e.g: Message Pushed to Moderation Queue
    status?: string;
    error?: string;
    submittedAt?: AppDate;
  };
  aiModerationResponse?: {
    // e.g.: "Passed"
    aiVerdict?: string;
    isContentModerated?: boolean;
    // e.g.: "Reasoning why it was failed by AI"
    message?: string;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  aiModerationLastError?: any;
  /**** moderation end ***/
}

export interface StorePreviewVideoUpload extends BaseVideoUpload {
  type: VideoUploadType.storePreview;
}

export type VideoUpload = StorePreviewVideoUpload;

export type HighlightVideo = {
  userId: string;
  createdAt: AppDate;
  url?: string;
  updatedAt?: AppDate;
  readAt?: AppDate;
};
